__turbopack_context__.v({
  "className": "JNc1LW_className",
  "variable": "JNc1LW_variable",
});
